<p style="margin-bottom : 30px;">
  Select Users
  <mat-button-toggle-group name="user" aria-label="user">
    <mat-button-toggle value="self">Self</mat-button-toggle>
    <mat-button-toggle value="all">All</mat-button-toggle>
    <mat-button-toggle value="teams">Teams</mat-button-toggle>
    <mat-button-toggle value="reps">Reps</mat-button-toggle>
    <mat-button-toggle value="office">Offices</mat-button-toggle>
  </mat-button-toggle-group>
</p>
<app-select-employee (selectedEmployees)="employeeSelectionChanged($event)"></app-select-employee>
<p style="margin-bottom : 30px;">
  Office Location
  <mat-button-toggle-group name="user" aria-label="user">
    <mat-button-toggle value="self">Bangalore Office</mat-button-toggle>
    <mat-button-toggle value="teams">Mumbai Office</mat-button-toggle>
    <mat-button-toggle value="reps">Delhi Office</mat-button-toggle>
  </mat-button-toggle-group>
</p>

<p style="margin-bottom : 30px;">
  Date Range
  <mat-button-toggle-group name="dateRange" aria-label="dateRange">
    <mat-button-toggle value="today">Today</mat-button-toggle>
    <mat-button-toggle value="yesterday">Yesterday</mat-button-toggle>
    <mat-button-toggle value="week">This Week</mat-button-toggle>
    <mat-button-toggle value="month">This Month</mat-button-toggle>
    <mat-button-toggle value="quarter">This Quarter</mat-button-toggle>
    <mat-button-toggle value="year">This Year</mat-button-toggle>
    <mat-button-toggle value="range">Custom Range</mat-button-toggle>
  </mat-button-toggle-group>
</p>

<p style="margin-bottom : 30px;">
  Frequency
  <mat-button-toggle-group name="frequency" aria-label="frequency">
    <mat-button-toggle value="daily">Daily</mat-button-toggle>
    <mat-button-toggle value="weekly">Weekly</mat-button-toggle>
    <mat-button-toggle value="monthly">Monthly</mat-button-toggle>
  </mat-button-toggle-group>
</p>

<mat-form-field appearance="fill">
  <mat-label>Call Types</mat-label>
  <mat-select [formControl]="toppings" multiple>
    <mat-select-trigger>
      {{toppings.value ? toppings.value[0] : ''}}
      @if (toppings.value?.length > 1) {
        <span class="example-additional-selection">
          (+{{toppings.value.length - 1}} {{toppings.value?.length === 2 ? 'other' : 'others'}})
        </span>
      }
    </mat-select-trigger>
    @for (topping of toppingList; track topping) {
      <mat-option [value]="topping">{{topping}}</mat-option>
    }
  </mat-select>
</mat-form-field>

<mat-form-field appearance="fill">
  <mat-label>Call Connect Status</mat-label>
  <mat-select [formControl]="toppings" multiple>
    <mat-select-trigger>
      {{toppings.value ? toppings.value[0] : ''}}
      @if (toppings.value?.length > 1) {
        <span class="example-additional-selection">
          (+{{toppings.value.length - 1}} {{toppings.value?.length === 2 ? 'other' : 'others'}})
        </span>
      }
    </mat-select-trigger>
    @for (topping of toppingList; track topping) {
      <mat-option [value]="topping">{{topping}}</mat-option>
    }
  </mat-select>
</mat-form-field>

<mat-form-field appearance="fill">
  <mat-label>Disposition Types</mat-label>
  <mat-select [formControl]="toppings" multiple>
    <mat-select-trigger>
      {{toppings.value ? toppings.value[0] : ''}}
      @if (toppings.value?.length > 1) {
        <span class="example-additional-selection">
          (+{{toppings.value.length - 1}} {{toppings.value?.length === 2 ? 'other' : 'others'}})
        </span>
      }
    </mat-select-trigger>
    @for (topping of toppingList; track topping) {
      <mat-option [value]="topping">{{topping}}</mat-option>
    }
  </mat-select>
</mat-form-field>

<mat-form-field appearance="fill">
  <mat-label>Called Contact Type</mat-label>
  <mat-select [formControl]="toppings" multiple>
    <mat-select-trigger>
      {{toppings.value ? toppings.value[0] : ''}}
      @if (toppings.value?.length > 1) {
        <span class="example-additional-selection">
          (+{{toppings.value.length - 1}} {{toppings.value?.length === 2 ? 'other' : 'others'}})
        </span>
      }
    </mat-select-trigger>
    @for (topping of toppingList; track topping) {
      <mat-option [value]="topping">{{topping}}</mat-option>
    }
  </mat-select>
</mat-form-field>

<mat-form-field appearance="fill">
  <mat-label>Call Duration</mat-label>
  <mat-select [formControl]="toppings" multiple>
    <mat-select-trigger>
      {{toppings.value ? toppings.value[0] : ''}}
      @if (toppings.value?.length > 1) {
        <span class="example-additional-selection">
          (+{{toppings.value.length - 1}} {{toppings.value?.length === 2 ? 'other' : 'others'}})
        </span>
      }
    </mat-select-trigger>
    @for (topping of toppingList; track topping) {
      <mat-option [value]="topping">{{topping}}</mat-option>
    }
  </mat-select>
</mat-form-field>

<mat-form-field appearance="fill">
  <mat-label>Time Range</mat-label>
  <mat-select [formControl]="toppings" multiple>
    <mat-select-trigger>
      {{toppings.value ? toppings.value[0] : ''}}
      @if (toppings.value?.length > 1) {
        <span class="example-additional-selection">
          (+{{toppings.value.length - 1}} {{toppings.value?.length === 2 ? 'other' : 'others'}})
        </span>
      }
    </mat-select-trigger>
    @for (topping of toppingList; track topping) {
      <mat-option [value]="topping">{{topping}}</mat-option>
    }
  </mat-select>
</mat-form-field>

<mat-form-field appearance="fill">
  <mat-label>Lead Sources</mat-label>
  <mat-select [formControl]="toppings" multiple>
    <mat-select-trigger>
      {{toppings.value ? toppings.value[0] : ''}}
      @if (toppings.value?.length > 1) {
        <span class="example-additional-selection">
          (+{{toppings.value.length - 1}} {{toppings.value?.length === 2 ? 'other' : 'others'}})
        </span>
      }
    </mat-select-trigger>
    @for (topping of toppingList; track topping) {
      <mat-option [value]="topping">{{topping}}</mat-option>
    }
  </mat-select>
</mat-form-field>

<mat-form-field appearance="fill">
  <mat-label>Contact Priority</mat-label>
  <mat-select [formControl]="toppings" multiple>
    <mat-select-trigger>
      {{toppings.value ? toppings.value[0] : ''}}
      @if (toppings.value?.length > 1) {
        <span class="example-additional-selection">
          (+{{toppings.value.length - 1}} {{toppings.value?.length === 2 ? 'other' : 'others'}})
        </span>
      }
    </mat-select-trigger>
    @for (topping of toppingList; track topping) {
      <mat-option [value]="topping">{{topping}}</mat-option>
    }
  </mat-select>
</mat-form-field>

<mat-form-field appearance="fill">
  <mat-label>Contact Owner</mat-label>
  <mat-select [formControl]="toppings" multiple>
    <mat-select-trigger>
      {{toppings.value ? toppings.value[0] : ''}}
      @if (toppings.value?.length > 1) {
        <span class="example-additional-selection">
          (+{{toppings.value.length - 1}} {{toppings.value?.length === 2 ? 'other' : 'others'}})
        </span>
      }
    </mat-select-trigger>
    @for (topping of toppingList; track topping) {
      <mat-option [value]="topping">{{topping}}</mat-option>
    }
  </mat-select>
</mat-form-field>

<mat-form-field appearance="fill">
  <mat-label>Calling Owner</mat-label>
  <mat-select [formControl]="toppings" multiple>
    <mat-select-trigger>
      {{toppings.value ? toppings.value[0] : ''}}
      @if (toppings.value?.length > 1) {
        <span class="example-additional-selection">
          (+{{toppings.value.length - 1}} {{toppings.value?.length === 2 ? 'other' : 'others'}})
        </span>
      }
    </mat-select-trigger>
    @for (topping of toppingList; track topping) {
      <mat-option [value]="topping">{{topping}}</mat-option>
    }
  </mat-select>
</mat-form-field>

<mat-form-field appearance="fill">
  <mat-label>Activity Type</mat-label>
  <mat-select [formControl]="toppings" multiple>
    <mat-select-trigger>
      {{toppings.value ? toppings.value[0] : ''}}
      @if (toppings.value?.length > 1) {
        <span class="example-additional-selection">
          (+{{toppings.value.length - 1}} {{toppings.value?.length === 2 ? 'other' : 'others'}})
        </span>
      }
    </mat-select-trigger>
    @for (topping of toppingList; track topping) {
      <mat-option [value]="topping">{{topping}}</mat-option>
    }
  </mat-select>
</mat-form-field>